export const onPupilTaggingSuccess = (data, get) => {
  const { userIds, tagName } = data;
  if (userIds && tagName) get().tagPupils(userIds, tagName);
};

export const onPupilUntaggingSuccess = (data, get) => {
  const { userIds, tagName } = data;
  if (userIds && tagName) get().untagPupils(userIds, tagName);
};
